module.exports = __webpack_public_path__ + "img/map.96d1eaa1be874b43e765e480d6c05e8f.svg";